<div class="confirm-modal ig-modal edit-place-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3 class="title">EDIT PLACE</h3>
    <!--    <div class="view-change-history" (click)="showChangeHistory()">View change history</div>-->

    <div class="flex justify-center" style="gap:12px">
        <div class="edit-wrap" [ngStyle]="{'width':aiGeneratedDescription.length?'50%':'100%'}">
            <div>
                <div class="edit-event-fields">
                    <div class="relative">
                        <ig-mat-field label="Name" [(ngModel)]="place.name" [isRequired]="true"
                            [formControl]="createPlaceForm.get('name')">
                        </ig-mat-field>
                        <div class="ig-place-info-lock" (click)="lockInfo('name')"
                            matTooltip="{{place.lock&&place.lock.name?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.name">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.name">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative">
                        <ig-address-input label="Location"
                            matTooltip="please type and select an address from the dropdown" [isRequired]="true"
                            [(ngModel)]="place.address" [formControl]="createPlaceForm.get('address')">
                        </ig-address-input>
                        <div class="ig-place-info-lock" style="top:42px" (click)="lockInfo('address')"
                            matTooltip="{{place.lock&&place.lock.address?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.address">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.address">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative">
                        <!-- <mat-form-field class="text-area m-t-2">
                            <textarea #descriptionTextarea matInput placeholder="Description" type="textArea"
                                class="transition-50" [(ngModel)]="place.description"
                                [formControl]="createPlaceForm.get('description')">
                            </textarea>                            
                        </mat-form-field> -->
                        <div class="place-description-label">
                            <span>Description</span>
                        </div>
                        <div class="text-area m-t-2 place-description">
                            <textarea id="description-editor"></textarea>
                        </div>
                        <div style="text-align:left">
                            <a (click)="generateDescription()" style="position:relative;"
                                [ngStyle]="{'top': isDescriptionNeedShowMore ? '0' : '0px'}">
                                <span *ngIf="!aiGeneratedDescription.length"
                                    [ngStyle]="{'text-decoration':isGeneratingDescription ? 'none' : 'underline'}"
                                    matTooltip="Using AI to generate an introduction for this place">
                                    {{isGeneratingDescription ? 'Generating description...' : 'Try our AI Content
                                    Assistant'}}
                                    <span *ngIf="!isGeneratingDescription&&!aiGeneratedDescription.length">
                                        <img src="https://iti-images.s3.amazonaws.com/imgs/ai-star.gif" alt=""
                                            width="20">
                                    </span>
                                </span>
                                <span *ngIf="aiGeneratedDescription.length">Description generated, please select
                                    one from the right side.</span>
                                <mat-icon *ngIf="isGeneratingDescription" matTooltip="Generating..." class="ig-spin"
                                    style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                                <mat-icon *ngIf="aiGeneratedDescription.length&&!isGeneratingDescription"
                                    matTooltip="Generate again" (click)="generateDescription()"
                                    style="font-size:16px;width:16px;height:16px">autorenew</mat-icon>
                            </a>
                            <a (click)="bulkGeneration()">Bulk Generation</a>
                        </div>
                        <div class="ig-place-info-lock" style="top:30px" (click)="lockInfo('description')"
                            matTooltip="{{place.lock&&place.lock.description?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.description">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.description">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative m-t-2">
                        <ig-mat-field label="Website" [(ngModel)]="place.website" [isRequired]="true"
                            [formControl]="createPlaceForm.get('website')">
                        </ig-mat-field>
                        <div class="ig-place-info-lock" (click)="lockInfo('website')"
                            matTooltip="{{place.lock&&place.lock.website?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.website">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.website">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative">
                        <ig-mat-field label="Phone" [(ngModel)]="place.phone"
                            [formControl]="createPlaceForm.get('phone')">
                        </ig-mat-field>
                        <div class="ig-place-info-lock" (click)="lockInfo('phone')"
                            matTooltip="{{place.lock&&place.lock.phone?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.phone">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.phone">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative">
                        <mat-form-field class="place-form-field ig-price-range">
                            <mat-select placeholder="Price Range" [(ngModel)]="place.priceRange"
                                [formControl]="createPlaceForm.get('priceRange')">
                                <mat-option value="1">$</mat-option>
                                <mat-option value="2">$$</mat-option>
                                <mat-option value="3">$$$</mat-option>
                                <mat-option value="4">$$$$</mat-option>
                                <mat-option value="null">N/A</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="ig-place-info-lock" (click)="lockInfo('priceRange')"
                            matTooltip="{{place.lock&&place.lock.priceRange?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.priceRange">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.priceRange">lock</mat-icon>
                        </div>
                    </div>

                    <div class="relative">
                        <mat-form-field class="place-form-field ig-price-range">
                            <mat-select placeholder="Business Status" [(ngModel)]="place.business_status"
                                [formControl]="createPlaceForm.get('business_status')"
                                (change)="businessStatusChanged($event)">
                                <mat-option value="OPERATIONAL">OPERATIONAL</mat-option>
                                <mat-option value="CLOSED_TEMPORARILY">CLOSED TEMPORARILY</mat-option>
                                <mat-option value="CLOSED_PERMANENTLY">CLOSED PERMANENTLY</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="ig-place-info-lock" (click)="lockInfo('business_status')"
                            matTooltip="{{place.lock&&place.lock.business_status?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.business_status">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.business_status">lock</mat-icon>
                        </div>
                    </div>

                    <!-- <div *ngIf="hasServes" class="relative">
                        <p>Services</p>
                        <div class="ig-place-info-lock" (click)="lockInfo('business_status')"
                            matTooltip="{{place.lock&&place.lock.services?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.services">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.services">lock</mat-icon>
                        </div>
                    </div> -->

                    <div class="category-editor relative">
                        <ig-mat-field label="Categories" [(ngModel)]="place.categoryText" [disabled]="true"
                            [matTooltip]="place.categoryText" [formControl]="createPlaceForm.get('categoryText')">
                        </ig-mat-field>

                        <div class="edit-google-images edit-category" (click)="showEditCategoryModal()">Edit Category
                        </div>
                        <!-- <div class="ig-place-info-lock" (click)="lockInfo('category')"
                            matTooltip="{{place.lock&&place.lock.category?'Locked':lockTip}}">
                            <mat-icon *ngIf="!place.lock||!place.lock.category">lock_open</mat-icon>
                            <mat-icon *ngIf="place.lock&&place.lock.category">lock</mat-icon>
                        </div> -->
                    </div>

                    <span class="ig-place-addition">Additional Info</span>
                    <hr>

                    <ig-mat-field label="Email" [(ngModel)]="place.ownerEmail"
                        [formControl]="createPlaceForm.get('email')">
                    </ig-mat-field>
                    <ig-mat-field label="Owner Phone" [(ngModel)]="place.ownerPhone"
                        [formControl]="createPlaceForm.get('ownerPhone')">
                    </ig-mat-field>

                    <ig-mat-field label="360 Video Key" matTooltip="E.g. 0V3ND-dzGvrv" [(ngModel)]="place._360VideoKey"
                        [formControl]="createPlaceForm.get('_360VideoKey')">
                    </ig-mat-field>

                    <ig-mat-field label="YouTube Video Link"
                        matTooltip="E.g. https://www.youtube.com/watch?v=1IDPN6vIDhI" [(ngModel)]="place.youtubeLink"
                        [formControl]="createPlaceForm.get('youtubeLink')">
                    </ig-mat-field>

                    <ng-container *ngIf="toggles && toggles.tour.audioTour">
                        <div class="text-align-start">
                            <mat-slide-toggle [checked]="place.audio &&place.audio.isActive"
                                (change)="toggleAudioTour()">
                                Add Audio Tour
                            </mat-slide-toggle>
                        </div>

                        <ig-mat-field [hidden]="!place.audio || !place.audio.isActive" label="Audio tour link"
                            matTooltip="Audio tour link" [(ngModel)]="place.audio.link"
                            [formControl]="createPlaceForm.get('audio_link')">
                        </ig-mat-field>

                        <ig-mat-field [hidden]="!place.audio || !place.audio.isActive" label="Audio tour description"
                            matTooltip="Audio tour description" [(ngModel)]="place.audio.description"
                            [formControl]="createPlaceForm.get('audio_description')">
                        </ig-mat-field>
                    </ng-container>

                    <ig-mat-field label="Facebook Page Link" matTooltip="Facebook Page Link"
                        [(ngModel)]="place.facebookLink" [formControl]="createPlaceForm.get('facebookLink')">
                    </ig-mat-field>

                    <ig-mat-field label="Place Link" [(ngModel)]="place.hostLink" [disabled]="true"
                        [formControl]="createPlaceForm.get('hostLink')">
                    </ig-mat-field>

                    <ig-row>
                        <ig-col [xs]="12" [md]="12" class="relative">
                            <ig-button *ngIf="showEditGoogleImagesBtn && !place.isManuallyCreated" size="md"
                                (trigger)="showEditImagesModal()" style="height: 50px">Edit Images</ig-button>

                            <ig-button *ngIf="place.isManuallyCreated" size="md" (trigger)="showEditImagesModal()"
                                style="height: 50px">Edit Images</ig-button>

                            <!-- <mat-radio-group class="radio-group" (ngModelChange)="imageWayChange()"
                                [(ngModel)]="isUploadImage" *ngIf="place.isManuallyCreated">
                                <div>
                                    <mat-radio-button [value]="true">
                                        Upload Image
                                    </mat-radio-button>

                                    <div class="relative">
                                        <img #img *ngIf="selectedImageData"
                                            [src]="imageService.safeImage(selectedImageData)" width="60%" alt="">

                                        <div #upload *ngIf="!selectedImageData" class="img-upload"
                                            (click)="isUploadImage&&imageSelector.click()">
                                            <mat-icon [class.pointer]="isUploadImage">photo</mat-icon>
                                            <p>Select Your Image</p>
                                            // <p>Image Size 2MB Maximum</p>
                                        </div>

                                        <div #mask *ngIf="selectedImageData" class="img-mask"
                                            (click)="imageSelector.click()">
                                            // <span *ngIf="isUploadImage">Change Image (2MB Maximum)</span>
                                        </div>
                                        <input type="file" class="invisible" accept="image/png,image/gif,image/jpeg"
                                            #imageSelector (change)="onImageChange($event)">
                                    </div>
                                </div>

                                <div>
                                    <mat-radio-button [value]="false">
                                        Image Link
                                    </mat-radio-button>

                                    <ig-mat-field label="Image Link" [disabled]="isUploadImage" [(ngModel)]="imageLink"
                                        (onModelChange)="isImageChanged=true"
                                        [formControl]="createPlaceForm.get('imageLink')">
                                    </ig-mat-field>
                                </div>
                            </mat-radio-group> -->
                        </ig-col>
                    </ig-row>

                </div>
            </div>
        </div>

        <div *ngIf="aiGeneratedDescription.length" style="width:50%;text-align:left;position:relative">
            <p style="font-weight:bold">AI generated descriptions:</p>

            <div *ngIf="isRegeneratingDescription" class="absolute full-width full-height top-0"
                style="opacity:0.7;background:white">
            </div>
            <div *ngIf="isRegeneratingDescription"
                class="absolute full-width full-height flex justify-center items-center top-0">
                <mat-icon class="ig-spin"
                    style="font-size: 40px;width:40px;height:40px;color:deepskyblue;cursor:default">autorenew</mat-icon>
            </div>

            <div *ngFor="let des of aiGeneratedDescription;let i = index" (click)="selectDescription(des)"
                [ngStyle]="{'outline':place.description === des ? '2px solid deepskyblue' : '2px dashed #ccc', 'cursor': isRegeneratingDescription? 'default' : 'pointer'}"
                style="margin:16px 2px 0 2px;border-radius:6px;height:15vh;overflow:auto;padding:8px 12px;cursor:pointer">
                <p style="margin-bottom:4px;font-weight:bold">Version {{i+1}}:</p>
                {{des}}
            </div>
        </div>
    </div>

    <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights">Please note that any images uploaded or used in
        this software must either be royalty-free or owned by the client. By uploading or using an image, you
        acknowledge that you have the necessary rights to use it and that you will be solely responsible for any
        copyright infringement or other legal issues that may arise from the use of the image. We strongly advise our
        users to exercise due diligence and ensure that they have the necessary rights to use any images uploaded or
        used in this software.
    </mat-checkbox>

    <div class="action-btns full-width">
        <ig-button class="btn-primary green-btn" style="flex:4"
            [disabled]="!createPlaceForm.valid|| (isImageChanged && !hasCopyrights)" #confirmButton color="primary"
            size="md" [isAsync]="true" (trigger)="confirm($event)">
            Save & publish changes
        </ig-button>
        <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
            Cancel
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.modal/edit.place.modal.component.html